import React from 'react';

export const RootNodeContext = React.createContext<Elvita.Node | undefined>(
  undefined,
);
